import React from 'react';
import { Link } from 'react-router-dom';

/**
 * BetaBadge - Small header pill telling testers the release is a beta
 * and its content is incomplete.
 */
export const BetaBadge: React.FC = () => (
  <span
    className="ml-2 inline-flex items-center rounded-full bg-golden-yellow/20 px-2 py-0.5 text-xs font-semibold uppercase tracking-wide text-neutral-800"
    title="ThinkSphere is in beta: content is still being added"
  >
    Beta
  </span>
);

export interface FeedbackPromptProps {
  /** mailto: or form URL; the "Send feedback" link is hidden when unset */
  feedbackUrl?: string;
  /** Show the "Flag for Review" hint; only signed-in users have quiz results */
  showFlagHint?: boolean;
}

/**
 * FeedbackPrompt - Footer prompt asking beta testers for general feedback,
 * and pointing them to "Flag for Review" on quiz results for problems with
 * a single question.
 */
export const FeedbackPrompt: React.FC<FeedbackPromptProps> = ({
  feedbackUrl = process.env.REACT_APP_FEEDBACK_URL,
  showFlagHint = false,
}) => {
  const opensNewTab = !!feedbackUrl && !feedbackUrl.startsWith('mailto:');

  return (
    <p className="text-center text-cool-gray text-sm">
      ThinkSphere is in beta: content is still being added.{' '}
      {feedbackUrl && (
        <>
          <a
            href={feedbackUrl}
            className="font-medium text-primary hover:underline"
            {...(opensNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
          >
            Send feedback
          </a>{' '}
        </>
      )}
      {showFlagHint && (
        <>
          Problem with a specific question? Use &ldquo;Flag for Review&rdquo; on your{' '}
          <Link to="/history" className="font-medium text-primary hover:underline">
            quiz results
          </Link>
          .
        </>
      )}
    </p>
  );
};
